<template>
  <div class="page-container specialities-container">
    <todo-side-bar selected="specialities" />
    <div class="container-head">
      <h1>{{ $t('pages.industries') }}</h1>
      <div class="flex">
        <div class="buttons">
          <el-button type="warning" round @click="download">
            {{ $t('professionalServices') }}
          </el-button>
        </div>
        <div class="buttons ml-4">
          <el-button type="warning" round @click="downloadServiceTypes">
            {{ $t('allServicesTypes') }}
          </el-button>
        </div>
      </div>

    </div>

    <el-row type="flex" class="specialities">
      <el-col :span="12" class="col-left">
        <ts-industries :selected="industry" @industry-change="changeIndustry" />
      </el-col>
      <el-col :span="12" class="col-right">
        <div class="tabs">
          <span
            v-for="tab in tabs"
            :key="'tab-' + tab"
            class="tab"
            :class="{selected: tab === activeTab}"
            @click="changeTab(tab)"
            v-text="$t('pages.' + tab)"
          />
        </div>
        <!--<ts-specialities v-show="activeTab === 'specialities'" :industry="industry" /> -->
        <ts-service-types v-show="activeTab === 'serviceTypes'" :industry="industry" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Industries from './components/Industries.vue'
  // import Specialities from './components/Specialities.vue'
  import ServiceTypes from './components/ServiceTypes.vue'
  import { getExcel } from '@/api/excel'

  export default {
    components: {
      'ts-industries': Industries,
      // 'ts-specialities': Specialities,
      'ts-service-types': ServiceTypes
    },

    data() {
      return {
        industry: null,
        tabs: ['serviceTypes'],
        activeTab: 'serviceTypes'
      }
    },

    methods: {
      changeIndustry(industry) {
        this.industry = industry
      },

      changeTab(tab) {
        this.activeTab = tab
      },

      async download() {
        const { data } = await getExcel('listServices', {})
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'report.xlsx')
        document.body.appendChild(link)
        link.click()
      },
      async downloadServiceTypes() {
        const { data } = await getExcel('listServicesTypes', {})
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'report.xlsx')
        document.body.appendChild(link)
        link.click()
      }
    }
  }
</script>

<style lang="scss">
  .specialities-container {
    .specialities {
      position: absolute;
      top: 120px;
      left: 230px;
      right: 40px;
      bottom: 10px;
    }
  }
</style>

<style lang="scss" scoped>
  @import '../../assets/variables';
  .flex{
    display: flex;
  }

  .ml-4{
    margin-left: 10px;
  }

  .col-left {
    border-right: 1px solid #E0E0E0;
    padding-right: 30px;
    padding-top: 50px;
    position: relative;
  }

  .col-right {
    margin-left: 40px;
    position: relative;
    padding-bottom: 180px;
  }

  .container-head {
    display: flex;
    justify-content: space-between;
  }

  .tabs {
    .tab {
      display: inline-block;
      padding-right: 30px;
      font-size: 20px;
      line-height: 30px;
      color: $color-text-regular;
      cursor: pointer;

      &.selected {
        font-weight: bold;
      }
    }
  }
</style>
